export const EXERCISE_FILTER_CRITERIA = [
  'categories',
  'muscles',
  'equipment',
  'developedSkills',
] as const;

export type ExerciseFiltersCriterion =
  (typeof EXERCISE_FILTER_CRITERIA)[number];

export interface IExerciseFilters {
  categories: string[];
  muscles: string[];
  equipment: string[];
  developedSkills: string[];
}

export interface IExerciseFilterOption {
  id: string;
  name: string;
}

export interface IExerciseFilterOptionIds {
  categories: Set<string>;
  muscles: Set<string>;
  equipment: Set<string>;
  developedSkills: Set<string>;
}

export interface IExerciseFiltersStorageValue {
  version: 1;
  filters: IExerciseFilters;
}

export const DEFAULT_EXERCISE_FILTERS: IExerciseFilters = {
  categories: [],
  muscles: [],
  equipment: [],
  developedSkills: [],
};

export function cloneExerciseFilters(
  filters: IExerciseFilters,
): IExerciseFilters {
  return {
    categories: [...filters.categories],
    muscles: [...filters.muscles],
    equipment: [...filters.equipment],
    developedSkills: [...filters.developedSkills],
  };
}

export function getAppliedExerciseFiltersCount(
  filters: IExerciseFilters,
): number {
  return EXERCISE_FILTER_CRITERIA.reduce(
    (count, criterion) => count + filters[criterion].length,
    0,
  );
}

export function sanitizeExerciseFilters(
  filters: IExerciseFilters,
  availableOptionIds: IExerciseFilterOptionIds,
): IExerciseFilters {
  return EXERCISE_FILTER_CRITERIA.reduce<IExerciseFilters>(
    (nextFilters, criterion) => {
      if (!availableOptionIds[criterion].size) {
        nextFilters[criterion] = [...filters[criterion]];
        return nextFilters;
      }
      nextFilters[criterion] = filters[criterion].filter((value) =>
        availableOptionIds[criterion].has(value),
      );
      return nextFilters;
    },
    cloneExerciseFilters(DEFAULT_EXERCISE_FILTERS),
  );
}
